import React from "react";
import { Grid, Select, MenuItem, makeStyles, Typography } from "@material-ui/core";
import countriesData from "./CountryCodes.json";

export const useStyles = makeStyles(() => ({
  selectRoot: {
    fontWeight: 400,
    fontSize: 14,
    textTransform: "capitalize",
    "&.MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
  },
  selectIcon: {
    right: -10,
  },
}));

function SelectCountry({ defaultValue, country, setCountry, containerStyle, selectRoots }) {
  const classes = useStyles();

  const handleChange = (e) => {
    setCountry(e.target.value);
  };

  return (
    <Grid container alignItems="baseline" wrap="nowrap" style={{ width: "20%" }}>
      <Typography variant="subtitle2" className={classes.selectRoot} classes={selectRoots}>
        {country}
      </Typography>
      <Select
        labelId="label"
        id="select"
        autoWidth={true}
        defaultValue={defaultValue ? defaultValue : ""}
        onChange={handleChange}
        disableUnderline
        value={country}
        classes={{
          root: classes.selectRoot,
          icon: `${classes.selectIcon} ${selectRoots}`,
        }}
        renderValue={() => defaultValue}
        style={containerStyle}
      >
        {countriesData.map((country) => (
          <MenuItem key={country.dial_code} value={country.dial_code} style={{ fontSize: 12 }}>
            {`${country.name}(${country.dial_code})`}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
}

export default SelectCountry;
